<template>
  <DBox :id="'cmp-catalog-tracks-sidewindow-licences'" :addButton="false">
    <NTable
      id="catalog-tracks-sidewindow-licences-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('licence_account')">
            <span  @click="onLicenceClick(item,account)" class="txtov ut-link ut-text-accent5" :title="item['licence_account_name']">
              {{ item["licence_account_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('licence_name')">
            <span  @click="onLicenceClick(item,account)" class="txtov ut-link ut-text-accent5" :title="item['licence_name']">
              {{ item["licence_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('licence_type')">
            <span class="txtov" :title="item['licence_type']">
              {{ item["type"] }}
            </span>
          </td>
          <td v-bind="tdcon('start')">
            <span class="txtov" :title="item['licence_account_name']">
              {{ item["licence_start"] }}
            </span>
          </td>
          <td v-bind="tdcon('end')">
            <span class="txtov" :title="item['licence_account_name']">
              {{ item["licence_end"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";

import { licenceAccountsListLDTRoutes, licencesListLDTRoutes } from "../../../licensing/router/routes";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedTrackDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    list: function() {
      return this.selectedTrackDetails.related_licences || [];
    },
    headers: function() {
      return [
        createTableHeader("licence_account", { f:1.2}),
        createTableHeader("licence_name"),
        createTableHeader("licence_type"),
        createTableHeader("start", {  }),
        createTableHeader("end", {  }),
      ];
    }
  },

  methods:{
    onLicenceClick: function (item,name) {

      const ldtRoutes = name==='account'?licenceAccountsListLDTRoutes:licencesListLDTRoutes
      const primaryKey = name==='account'?'licence_account_id':'licence_id'

      this.$router.push({
        name: ldtRoutes.names.tab,
        params: {
          [primaryKey]: item[primaryKey],
          tab: "overview"
        }
      });
    },
  }
};
</script>
